import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const GetPublicOrderEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.getPublicOrderRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return OrderRepository.getOrderWithToken(action.payload.orderId, action.payload.token).pipe(
        mergeMap((response) => of(order.getPublicOrderSuccess(response))),
        catchError((error) => of(order.getPublicOrderFailure(error)))
      )
    })
  )
